import { render } from "./loading-spinner.html?vue&type=template&id=73458323&scoped=true&ts=true"
import script from "./loading-spinner.vue?vue&type=script&lang=ts"
export * from "./loading-spinner.vue?vue&type=script&lang=ts"

import "./loading-spinner.scss?vue&type=style&index=0&id=73458323&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73458323"]])

export default __exports__